import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CoreLandingFixService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  addFix(): void {
    this.document.documentElement.classList.add('landing');
    this.document.body.classList.add('landing');
  }

  removeFix(): void {
    this.document.documentElement.classList.remove('landing');
    this.document.body.classList.remove('landing');
  }
}
